/* =========================================================
   TERSA — interacciones. Vanilla, sin librerías.
   Cada init comprueba si su elemento existe.
   ========================================================= */
(function () {
  'use strict';

  var REDUCIDO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveals al hacer scroll (un solo observer + red de seguridad) ---------- */
  var observador = null;
  var pendientes = [];
  var revisando = false;

  function marcar(el) {
    el.classList.add('mt-visible');
    if (observador) observador.unobserve(el);
    var i = pendientes.indexOf(el);
    if (i > -1) pendientes.splice(i, 1);
  }

  /* Red de seguridad: si por lo que sea el observador no dispara (pestaña en
     segundo plano, navegador raro...), esto revisa a mano lo que ya está en
     pantalla. Sin esto, un fallo del observador dejaría la página en blanco. */
  function revisarAMano() {
    revisando = false;
    var alto = window.innerHeight || document.documentElement.clientHeight;
    for (var i = pendientes.length - 1; i >= 0; i--) {
      var el = pendientes[i];
      if (!el.isConnected) { pendientes.splice(i, 1); continue; }
      var r = el.getBoundingClientRect();
      if (r.top < alto * 0.94 && r.bottom > 0) marcar(el);
    }
  }
  function pedirRevision() {
    if (revisando) return;
    revisando = true;
    /* requestAnimationFrame se para en pestañas ocultas: ahí usamos un temporizador */
    if (document.hidden || !window.requestAnimationFrame) setTimeout(revisarAMano, 60);
    else window.requestAnimationFrame(revisarAMano);
  }

  function initReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll('.mt-reveal, .mt-reveal-mask, .mt-reveal-img');
    if (!elementos.length) return;

    if (REDUCIDO) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador && 'IntersectionObserver' in window) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) marcar(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    elementos.forEach(function (el) {
      if (el.classList.contains('mt-visible')) return;
      var d = el.getAttribute('data-mt-delay');
      if (d) el.style.setProperty('--mt-delay', d + 'ms');
      pendientes.push(el);
      if (observador) observador.observe(el);
    });

    if (!window.mtRevealOn) {
      window.mtRevealOn = true;
      window.addEventListener('scroll', pedirRevision, { passive: true });
      window.addEventListener('resize', pedirRevision, { passive: true });
      window.addEventListener('load', pedirRevision);
      window.addEventListener('pageshow', pedirRevision);
      document.addEventListener('visibilitychange', pedirRevision);
    }
    pedirRevision();
    setTimeout(pedirRevision, 400);
    setTimeout(pedirRevision, 1500);
  }

  /* ---------- 2. Parallax suave (solo transform) ---------- */
  var capas = [];
  var tickeando = false;
  function pintarParallax() {
    var vh = window.innerHeight;
    capas.forEach(function (c) {
      var r = c.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var centro = r.top + r.height / 2;
      var avance = (centro - vh / 2) / vh;
      c.el.style.transform = 'translate3d(0,' + (avance * c.fuerza * -1).toFixed(2) + 'px,0)';
    });
    tickeando = false;
  }
  function initParallax(raiz) {
    if (REDUCIDO) return;
    var els = (raiz || document).querySelectorAll('[data-mt-parallax]');
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.dataset.mtParallaxListo) return;
      el.dataset.mtParallaxListo = '1';
      capas.push({ el: el, fuerza: parseFloat(el.getAttribute('data-mt-parallax')) || 40 });
    });
    if (capas.length && !window.mtParallaxOn) {
      window.mtParallaxOn = true;
      window.addEventListener('scroll', function () {
        if (tickeando) return;
        tickeando = true;
        window.requestAnimationFrame(pintarParallax);
      }, { passive: true });
      window.addEventListener('resize', pintarParallax, { passive: true });
    }
    pintarParallax();
  }

  /* ---------- 3. Comparador antes / después ---------- */
  function initComparador(raiz) {
    var cajas = (raiz || document).querySelectorAll('[data-mt-comparador]');
    cajas.forEach(function (caja) {
      if (caja.dataset.mtListo) return;
      caja.dataset.mtListo = '1';

      var arrastrando = false;
      function fijar(x) {
        var r = caja.getBoundingClientRect();
        var pct = ((x - r.left) / r.width) * 100;
        pct = Math.max(1, Math.min(99, pct));
        caja.style.setProperty('--mt-x', pct + '%');
      }
      function abajo(e) {
        arrastrando = true;
        fijar(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function mover(e) {
        if (!arrastrando) return;
        fijar(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function arriba() { arrastrando = false; }

      caja.addEventListener('mousedown', abajo);
      caja.addEventListener('touchstart', abajo, { passive: true });
      window.addEventListener('mousemove', mover);
      window.addEventListener('touchmove', mover, { passive: true });
      window.addEventListener('mouseup', arriba);
      window.addEventListener('touchend', arriba);
      caja.addEventListener('mousemove', function (e) { if (!arrastrando) fijar(e.clientX); });

      /* barrido de presentación la primera vez que entra en pantalla */
      if (!REDUCIDO && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(caja);
            var ini = 82, fin = 42, t0 = null, dur = 1500;
            caja.style.setProperty('--mt-x', ini + '%');
            function paso(t) {
              if (!t0) t0 = t;
              var p = Math.min(1, (t - t0) / dur);
              var e = 1 - Math.pow(1 - p, 3);
              caja.style.setProperty('--mt-x', (ini + (fin - ini) * e).toFixed(2) + '%');
              if (p < 1) window.requestAnimationFrame(paso);
            }
            window.requestAnimationFrame(paso);
          });
        }, { threshold: 0.4 });
        io.observe(caja);
      }
    });
  }

  /* ---------- 4. Pasos con escena sticky ---------- */
  function initPasos(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-pasos]');
    bloques.forEach(function (bloque) {
      if (bloque.dataset.mtListo) return;
      bloque.dataset.mtListo = '1';

      var items = bloque.querySelectorAll('.mt-pasos__item');
      var fotos = bloque.querySelectorAll('.mt-pasos__foto');
      if (!items.length || !fotos.length) return;

      var dur = parseInt(bloque.getAttribute('data-mt-pasos'), 10) || 5000;
      var actual = 0;
      var reloj = null;

      function activar(i) {
        actual = i;
        items.forEach(function (it, k) { it.classList.toggle('mt-activo', k === i); });
        fotos.forEach(function (ft, k) { ft.classList.toggle('mt-activo', k === i); });
        /* reinicia la animación de la barra */
        var barra = items[i].querySelector('.mt-pasos__barra span');
        if (barra) { barra.style.animation = 'none'; void barra.offsetWidth; barra.style.animation = ''; }
      }
      function arrancar() {
        if (reloj || REDUCIDO) return;
        reloj = setInterval(function () { activar((actual + 1) % items.length); }, dur);
      }
      function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }

      items.forEach(function (it, k) {
        it.addEventListener('click', function () { parar(); activar(k); arrancar(); });
        it.addEventListener('mouseenter', parar);
        it.addEventListener('mouseleave', arrancar);
      });

      activar(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (ents) {
          ents.forEach(function (e) { e.isIntersecting ? arrancar() : parar(); });
        }, { threshold: 0.25 }).observe(bloque);
      } else { arrancar(); }
    });
  }

  /* ---------- 5. FAQ acordeón ---------- */
  function initFaq(raiz) {
    var listas = (raiz || document).querySelectorAll('[data-mt-faq]');
    listas.forEach(function (lista) {
      if (lista.dataset.mtListo) return;
      lista.dataset.mtListo = '1';
      var items = lista.querySelectorAll('.mt-faq__item');

      items.forEach(function (item) {
        var btn = item.querySelector('.mt-faq__btn');
        var panel = item.querySelector('.mt-faq__panel');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-abierto');
          items.forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('mt-abierto');
            var p = otro.querySelector('.mt-faq__panel');
            var b = otro.querySelector('.mt-faq__btn');
            if (p) p.style.height = '0px';
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (abierto) {
            item.classList.remove('mt-abierto');
            panel.style.height = '0px';
            btn.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('mt-abierto');
            panel.style.height = panel.firstElementChild.offsetHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (!item.classList.contains('mt-abierto')) return;
          var panel = item.querySelector('.mt-faq__panel');
          if (panel) panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        });
      }, { passive: true });
    });
  }

  /* ---------- 6. Cifras animadas ---------- */
  function initCifras(raiz) {
    var nums = (raiz || document).querySelectorAll('[data-mt-cifra]');
    if (!nums.length) return;
    if (REDUCIDO || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-cifra-pre') + n.getAttribute('data-mt-cifra') + n.getAttribute('data-mt-cifra-post'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var fin = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
        var dec = (el.getAttribute('data-mt-cifra').split('.')[1] || '').length;
        var pre = el.getAttribute('data-mt-cifra-pre') || '';
        var post = el.getAttribute('data-mt-cifra-post') || '';
        var t0 = null, dur = 1700;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + (fin * ease).toFixed(dec) + post;
          if (p < 1) window.requestAnimationFrame(paso);
        }
        window.requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 7. Página de producto: galería + variantes ---------- */
  function initProducto(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-producto]');
    bloques.forEach(function (bloque) {
      if (bloque.dataset.mtListo) return;
      bloque.dataset.mtListo = '1';

      /* galería */
      var minis = bloque.querySelectorAll('.mt-prod__mini');
      var grandes = bloque.querySelectorAll('.mt-prod__principal .mt-img');
      function mostrar(i) {
        grandes.forEach(function (g, k) { g.style.opacity = k === i ? '1' : '0'; });
        minis.forEach(function (m, k) { m.classList.toggle('mt-activo', k === i); });
      }
      if (minis.length) {
        minis.forEach(function (m, k) { m.addEventListener('click', function () { mostrar(k); }); });
        mostrar(0);
      }

      /* variantes */
      var datos = bloque.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var botones = bloque.querySelectorAll('.mt-prod__valor');
      var inputId = bloque.querySelector('[data-mt-variante-id]');
      var precioEl = bloque.querySelector('[data-mt-precio]');
      var tachadoEl = bloque.querySelector('[data-mt-precio-tachado]');
      var btnAdd = bloque.querySelector('[data-mt-add]');
      var textoAdd = btnAdd ? btnAdd.getAttribute('data-mt-add') : '';
      var textoAgotado = btnAdd ? btnAdd.getAttribute('data-mt-agotado') : '';
      var stockEl = bloque.querySelector('[data-mt-stock]');
      if (!botones.length) return;

      var seleccion = [];
      bloque.querySelectorAll('.mt-prod__opcion').forEach(function (op, idx) {
        var act = op.querySelector('.mt-prod__valor.mt-activo') || op.querySelector('.mt-prod__valor');
        seleccion[idx] = act ? act.getAttribute('data-mt-valor') : null;
      });

      function moneda(c) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
            style: 'currency', currency: datos.getAttribute('data-mt-moneda') || 'EUR'
          }).format(c / 100);
        } catch (e) { return (c / 100).toFixed(2); }
      }

      function refrescar() {
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === seleccion[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = moneda(v.price);
        if (tachadoEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachadoEl.textContent = moneda(v.compare_at_price);
            tachadoEl.style.display = '';
          } else { tachadoEl.style.display = 'none'; }
        }
        if (btnAdd) {
          btnAdd.disabled = !v.available;
          btnAdd.textContent = v.available ? textoAdd : textoAgotado;
        }
        if (stockEl) stockEl.style.display = v.available ? '' : 'none';
      }

      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var grupo = b.closest('.mt-prod__opcion');
          var idx = parseInt(grupo.getAttribute('data-mt-opcion'), 10);
          grupo.querySelectorAll('.mt-prod__valor').forEach(function (o) { o.classList.remove('mt-activo'); });
          b.classList.add('mt-activo');
          seleccion[idx] = b.getAttribute('data-mt-valor');
          refrescar();
        });
      });
      refrescar();
    });
  }

  /* ---------- arranque ---------- */
  function initTodo(raiz) {
    initReveals(raiz);
    initParallax(raiz);
    initComparador(raiz);
    initPasos(raiz);
    initFaq(raiz);
    initCifras(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  /* el editor de Shopify recarga secciones sueltas: re-inicializa */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
